import { useLocation, useParams } from 'react-router-dom';
import { ProductionMasters } from '../../../../api/model';
import ErrorComponent from '../../../atoms/ErrorComponent';
import {
  ProductionApprovalApplicationAdd,
  ProductionApprovalApplicationEdit,
} from './ProductionApprovalApplicationEdit';
import ProductionApprovalApplicationList from './ProductionApprovalApplicationList';

// 承認申請ステータスID(1:新規作成 2:承認待ち 3:承認済み 4:否認)
export const ApprovalApplicationStatuses = {
  new: 1,
  requested: 2,
  approved: 3,
  rejected: 4,
};

// 申請種別(1:承認申請 2:削除申請 3:再編集申請)
export const ApprovalApplicationTypes = {
  approval: 1,
  deletion: 2,
  reEditing: 3,
};

interface Props {
  productionId: number;
  masters: ProductionMasters;
}

/**
 * 承認タブ
 * @param param0
 * @returns
 */
function ProductionApprovalApplicationsTab({ productionId, masters }: Props) {
  const {
    approvalApplicationTypeId: approvalApplicationTypeIdParam,
    approvalApplicationId: approvalApplicationIdParam,
  } = useParams();

  const location = useLocation();
  const isEdit = location.pathname.match(/.+approval-application\/edit\/.+/) != null;
  const isView = location.pathname.match(/.+approval-application\/view\/.+/) != null;
  const isAdd = location.pathname.match(/.+approval-application\/add\/.+/) != null;

  if (isEdit || isView) {
    return approvalApplicationIdParam ? (
      <ProductionApprovalApplicationEdit
        productionId={productionId}
        approvalApplicationId={+approvalApplicationIdParam}
        isReadonly={isView}
        masters={masters}
      />
    ) : (
      <ErrorComponent error={null} />
    );
  }

  if (isAdd) {
    return approvalApplicationTypeIdParam ? (
      <ProductionApprovalApplicationAdd
        productionId={productionId}
        approvalApplicationTypeId={+approvalApplicationTypeIdParam}
        masters={masters}
      />
    ) : (
      <ErrorComponent error={null} />
    );
  }

  return <ProductionApprovalApplicationList productionId={productionId} />;
}

export default ProductionApprovalApplicationsTab;
